<template>
    <section class="contact-us-view">
        <HeaderComponent :title="'Fale Conosco'"/>

        <label for="assunto">Assunto</label>
        <select v-model="selectedOption" class="custom-select" id="assunto">
            <option value="Elogio">Elogio</option>
            <option value="Solicitação de Novo Cartão">Solicitação de Novo Cartão</option>
            <option value="Dúvida">Dúvida</option>
            <option value="Financeiro">Financeiro</option>
            <option value="Reclamação">Reclamação</option>
        </select>

        <InputContainer :inputs="inputs" ref="contactInputs"/>

        <label for="message">Mensagem</label>
        <textarea id="message" class="message" rows="5" placeholder="Mensagem" ref="message" maxlength="500"></textarea>

        <footer>
            <div class="button-cont" v-if="!sending">
                <ButtonCenter :button="buttonSend" style="width: calc(100% - 30%);" @click="buttonSend.action && buttonSend.action()" />
            </div>
            <h1 id="exporting" v-else-if="sending">
                Enviando
                <i class="fa fa-spinner fa-spin fa-fw"></i>
            </h1>
        </footer>
</section>
</template>

<script>
import HeaderComponent from '@/components/header/HeaderComponent.vue'
import InputContainer from '@/components/inputs/InputContainer.vue'
import ButtonCenter from '@/components/buttons/center/ButtonCenter.vue'
import { showAlertNotification, showSuccessNotification, showErrorNotification } from '@/libs/Util.js'
import { sendEmail } from '@/components/controllers/EmailController.js'
import { getConsumerDetailsRaw } from '@/components/controllers/ConsumerController.js'

export default {
    name: 'ContactUsView',
    components: {
        HeaderComponent,
        InputContainer,
        ButtonCenter
    },
    data () {
        return {
            inputs: [
                {
                    display: 'Email',
                    placeHolder: 'E-mail',
                    type: 'email',
                    required: false,
                    half: true
                },
                {
                    display: 'Celular',
                    placeHolder: 'Telefone',
                    type: 'text',
                    required: false,
                    half: true,
                    format: 'cellNumber'
                }
            ],
            selectedOption: '',
            buttonSend: {
                display: 'Enviar',
                fill: true,
                action: this.send
            },
            sending: false
        }
    },
    methods: {
        send: async function () {
            const subject = this.selectedOption
            const message = this.$refs.message.value
            const contactData = this.$refs.contactInputs.getValues()
            const email = contactData[0].value
            const phone = contactData[1].value

            if (!subject || !message) {
                return showAlertNotification({
                    title: '',
                    text: 'Preencha os campos obrigatórios: Assunto, Mensagem!'
                })
            }

            const regexValidateEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
            if (email && !regexValidateEmail.test(email)) {
                return showAlertNotification({
                    title: '',
                    text: 'Preencha um e-mail válido!'
                })
            }

            this.sending = true
            getConsumerDetailsRaw().then((res) => {
                const CDCLIENTE = res?.CDCLIENTE
                const NMRESPCONS = res?.NMRESPCONS || res.NMCONSUMIDOR
                const NRCPFRESPCON = res?.NRCPFRESPCON
                const DSEMAILCONS = res?.DSEMAILCONS
                const NRTELECONS = res?.NRTELECONS ? res.NRTELECONS : res?.NRCELULARCONS

                const data = {
                    CDCLIENTE: CDCLIENTE,
                    NMRESPCONS: NMRESPCONS,
                    NRCPFRESPCON: NRCPFRESPCON,
                    email: email || DSEMAILCONS,
                    phone: phone || NRTELECONS,
                    subject: subject,
                    message: message
                }
                sendEmail(subject + ' - NoCash', null, true, 'getContactUsEmail', data).then((res) => {
                    if (!res.error) {
                        showSuccessNotification({
                            title: '',
                            text: 'E-mail enviado com sucesso!'
                        })
                    } else {
                        showErrorNotification({
                            title: '',
                            text: 'Erro ao enviar e-mail!'
                        })
                    }
                    this.sending = false
                    this.resetData()
                })
            })
        },
        resetData: function () {
            this.selectedOption = ''
            this.$refs.message.value = ''
            this.$refs.contactInputs.clearInput()
        }
    }
}
</script>

<style lang="less" scoped>
.custom-select {
    width: 100%;
    padding: 15px;
    border-radius: 30px;
    font-size: 16px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 7px;
    margin-top: 10px;
    margin-bottom: 15px;
}

label {
    margin-bottom: 5px;

    &:after{
        content: '*';
        color: red;
        margin-left: 5px;
    }
}

.message {
    width: calc(100% - 30px);
    padding: 15px;
    border-radius: 30px;
    font-size: 16px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 7px;
    margin-top: 10px;
    margin-bottom: 15px;
    font-family: inherit;
}

footer {
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    left: 0px;

    .button-cont {
        margin-top: 50px;
    }

    #exporting {
        font-size: 16px;
        font-weight: 600;
        color: var(--primaryColor);
        text-align: center;
        margin-top: 50px;
    }
}
</style>
